module.exports = __webpack_public_path__ + "c1c4a73c28b39abb9eb860073ba995d4.svg";